import { FirmaDigitalContainer } from "./localStyle";
import { useContext, useEffect, useRef, useState } from "react";
import SignaturePad from "react-signature-canvas";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { PortalContext } from "_+_Portal/context/Provider";
import { IonSpinner } from "@ionic/react";

const FirmaDocumento = ({ onClick, onChange }) => {
  //#region --------- context ---------------
  const { ordenEstudioState } = useContext(PortalContext);
  //#endregion  ----------- context ---------------

  //#region  ----------- constants ---------------
  let sigPad = useRef({});
  const [cargarPad, setCargarPad] = useState(false);
  const [disabled, setDisabled] = useState(true);
  //#endregion --------- constants ---------------

  //#region  ----------- funciones ---------------
  const limpiarFirma = () => {
    sigPad.current.clear();
    setDisabled(true);
  };

  const firmaPad = () => {
    setDisabled(false);
    return new Promise((resolve) => {
      let baseURL = "";
      baseURL = sigPad.current.toDataURL();
      resolve({ baseURL });
      onChange(baseURL.replace("data:image/png;base64,", ""));
    });
  };
  //#endregion --------- funciones ---------------

  //#region  ----------- useEffect ---------------

  useEffect(() => {
    //reseteo de firma por si giran el mobile
    const handleResize = () => {
      setDisabled(true);
    };
    window.addEventListener("resize", handleResize);
  }, []);

  //este timeout lo necesita porque sino carga con error el pad
  useEffect(() => {
    setTimeout(() => {
      setCargarPad(true);
    }, 250);
  }, []);
  //#endregion  ----------- useEffect ---------------

  return (
    <FirmaDigitalContainer>
      <div className="firma-box">
        {/* <Loading
          dataLoading={!cargarPad}
          color="c-white"
          descripcion={"Cargando..."}
        /> */}
        <div className="firma-box-pad">
          {cargarPad && (
            <SignaturePad
              ref={sigPad}
              onEnd={firmaPad}
              penColor="black"
              canvasProps={{ className: "sigCanvas" }}
            />
          )}
        </div>
        <div className="firma-box-botones">
          <div className="btn-firma bgc-latex30  rb16m" onClick={limpiarFirma}>
            <span className="c-white">Limpiar</span>
          </div>
          <div
            className={
              !disabled
                ? "btn-firma bgc-primary rb16m"
                : "btn-firma bgc-grey65 rb16m"
            }
            onClick={() => onClick(disabled)}
            disabled={disabled || ordenEstudioState.ordenEstudio.loading}
          >
            {ordenEstudioState.ordenEstudio.loading === true ? (
              <div className="c-white" style={{ marginTop: 3 }}>
                {" "}
                <IonSpinner name="lines-small" />
              </div>
            ) : (
              <span className="c-white">Firmar</span>
            )}
          </div>
        </div>
      </div>
    </FirmaDigitalContainer>
  );
};

export default FirmaDocumento;
